import { z } from "zod";

/** Fields Telegram embeds in the `user` field of initData (JSON-encoded). */
export const telegramUserSchema = z.object({
  id: z.number().int().positive(),
  first_name: z.string().min(1),
  last_name: z.string().optional(),
  username: z.string().optional(),
  language_code: z.string().optional(),
  is_premium: z.boolean().optional(),
  photo_url: z.string().url().optional(),
});

export type TelegramUser = z.infer<typeof telegramUserSchema>;

/** Result of successfully verifying and parsing a Telegram initData string. */
export const verifiedInitDataSchema = z.object({
  user: telegramUserSchema,
  authDate: z.number().int().positive(),
  queryId: z.string().optional(),
  chatInstance: z.string().optional(),
  chatType: z.string().optional(),
});

export type VerifiedInitData = z.infer<typeof verifiedInitDataSchema>;
